import { Route } from 'vue-router'
import rootStore from '@vue-storefront/core/store'
import { isServer } from '@vue-storefront/core/helpers'

export async function beforeEach(to: Route, from: Route, next) {
  if (!rootStore.getters['user/isLoggedIn'] || isServer) return next()
  await rootStore.dispatch('category/allCategories')
  return next()
}
